import { v4 as uuid } from "uuid";
import { FirebaseAdapter } from "./firebase-adapter";
import { Firepad } from "./firepad";
import { MonacoAdapter } from "./monaco-adapter";
import * as Utils from "./utils";
export function fromMonaco(databaseRef, editor, options = {}) {
    const userId = options.userId || uuid();
    const userColor = options.userColor || Utils.colorFromUserId(userId.toString());
    const userName = options.userName || userId.toString();
    const defaultText = options.defaultText || editor.getValue();
    const databaseAdapter = new FirebaseAdapter(databaseRef, userId, userColor, userName);
    const editorAdapter = new MonacoAdapter(editor, false);
    return new Firepad(databaseAdapter, editorAdapter, {
        userId,
        userName,
        userColor,
        defaultText,
    });
}
